export const getTrackingLinkV2 = (country, shipping, posts = []) => {
	const { tracking_link, waybill_number, curier_name, curierId } = shipping;

	const postData = posts.find(
		(p) => p._id === curierId || p.curier_name === curier_name,
	);

	if (postData?.tracking_link) {
		return `${postData.tracking_link}${waybill_number}`;
	}

	if (tracking_link) {
		return `${tracking_link}${waybill_number}`;
	}

	const countryCode = country?.toLowerCase();

	switch (countryCode) {
		case 'cz':
			return `https://www.postaonline.cz/en/trackandtrace/-/zasilka/cislo?parcelNumbers=${waybill_number}`;
		case 'sk':
			const name = postData?.name || curier_name;
			return name === 'sp'
				? `https://tandt.posta.sk/en/items/${waybill_number}`
				: `https://123kurier.jpsoftware.sk/sledovanie-zasielky?number=${waybill_number}`;
		case 'ro':
			return `https://www.fancourier.ro/en/awb-tracking/?metoda=tracking&bar_size=x&limba=romana&awb=${waybill_number}`;
		case 'hu':
			return `https://posta.hu/nyomkovetes/nyitooldal?searchvalue=${waybill_number}`;
		default:
			return '#';
	}
};
